var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 15.565a7.452 7.452 0 0 0-5.444-7.164C17.356 3.735 13.497 0 8.782 0 3.94 0 0 3.94 0 8.782c0 1.578.42 3.115 1.218 4.464L.032 17.532l4.286-1.185a8.75 8.75 0 0 0 4.083 1.208A7.452 7.452 0 0 0 15.565 23c1.339 0 2.64-.356 3.783-1.034l3.62 1.002-1.002-3.62A7.408 7.408 0 0 0 23 15.565zM4.531 14.89l-2.566.71.71-2.566-.162-.253a7.41 7.41 0 0 1-1.165-3.998c0-4.1 3.335-7.434 7.434-7.434 4.1 0 7.435 3.335 7.435 7.434 0 4.1-3.335 7.435-7.435 7.435a7.41 7.41 0 0 1-3.998-1.166l-.253-.162zm16.504 6.146-1.904-.527-.254.166c-.986.64-2.131.978-3.312.978a6.102 6.102 0 0 1-5.77-4.146 8.799 8.799 0 0 0 7.71-7.711 6.103 6.103 0 0 1 4.147 5.77c0 1.18-.338 2.326-.978 3.312l-.166.254.527 1.904z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.108 12.174h1.348v1.347H8.108zM10.13 6.738c0 .383-.156.736-.439.995L8.108 9.182v1.644h1.348v-1.05l1.145-1.049c.557-.51.877-1.234.877-1.989a2.698 2.698 0 0 0-2.696-2.695 2.698 2.698 0 0 0-2.695 2.695h1.348a1.35 1.35 0 0 1 1.347-1.347 1.35 1.35 0 0 1 1.348 1.347z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.64e308e5f57a718e49a6a3bd13329ecc.svg";
export { ForwardRef as ReactComponent };